const translations = {
  en: {
    withdrawUsing: 'Withdraw using',
    firstName: 'First Name:',
    firstNamePlaceholder: 'first name',
    lastName: 'Last name:',
    lastNamePlaceholder: 'last name',
    phone: 'Phone Number:',
    phonePlaceholder: 'phone #',
    country: 'Country:',
    countryPlaceholder: 'Country',
    state: 'State:',
    stateProvPlaceholder: 'State / Prov',
    amount: 'Amount:',
    currency: 'Currency',
    amountPlaceholder: 'Amount',
    payoutLimits: 'PayoutLimits: Minimum',
    maximum: 'Maximum',
    noLimit: 'No Limit',
    beneficiaryBankInfo: 'Beneficiary Bank information',
    accountNumber: 'Account Number:',
    accountNumberPlaceholder: 'Account Number',
    swiftCode: 'Swift Code:',
    swiftCodePlaceholder: 'Swift Code',
    bankName: 'Bank name:',
    bankNamePlaceholder: 'bank name',
    bankCountry: 'Bank Country:',
    bankState: 'Bank State:',
    bankCity: 'Bank City:',
    bankCityPlaceholder: 'bank city',
    bankAddress: 'Bank Address:',
    bankAddressPlaceholder: 'bank address',
    intermediaryBankInfo: 'Intermediary Bank information',
    back: 'BACK',
    submit: 'SUBMIT',
    warning: 'Warning',
    error: 'Error',
    amountRequired: 'Amount required',
    withdrawalStatus: 'Withdrawal Status',
    amountNotPermitted: 'amount not permitted, please check your withdrawal balance',
    errorGettingCustomerInfo: 'Error getting customer info: ',
  },
  es: {
    withdrawUsing: 'Retirar usando',
    firstName: 'Nombre:',
    firstNamePlaceholder: 'nombre',
    lastName: 'Apellido:',
    lastNamePlaceholder: 'apellido',
    phone: 'Número de Teléfono:',
    phonePlaceholder: 'teléfono #',
    country: 'País:',
    countryPlaceholder: 'País',
    state: 'Estado:',
    stateProvPlaceholder: 'Estado / Provincia',
    amount: 'Monto:',
    currency: 'Moneda',
    amountPlaceholder: 'Monto',
    payoutLimits: 'Límites de retiro: Mínimo',
    maximum: 'Máximo',
    noLimit: 'Sin Límite',
    beneficiaryBankInfo: 'Información del Banco Beneficiario',
    accountNumber: 'Número de Cuenta:',
    accountNumberPlaceholder: 'Número de Cuenta',
    swiftCode: 'Código Swift:',
    swiftCodePlaceholder: 'Código Swift',
    bankName: 'Nombre del banco:',
    bankNamePlaceholder: 'nombre del banco',
    bankCountry: 'País del Banco:',
    bankState: 'Estado del Banco:',
    bankCity: 'Ciudad del Banco:',
    bankCityPlaceholder: 'ciudad del banco',
    bankAddress: 'Dirección del Banco:',
    bankAddressPlaceholder: 'dirección del banco',
    intermediaryBankInfo: 'Información del Banco Intermediario',
    back: 'ATRÁS',
    submit: 'ENVIAR',
    warning: 'Advertencia',
    error: 'Error',
    amountRequired: 'Monto requerido',
    withdrawalStatus: 'Estado del Retiro',
    amountNotPermitted: 'Monto no permitido, por favor verifique su saldo disponible para retiro',
    errorGettingCustomerInfo: 'Error al obtener información del cliente: ',
  },
  pt: {
    withdrawUsing: 'Sacar usando',
    firstName: 'Nome:',
    firstNamePlaceholder: 'nome',
    lastName: 'Sobrenome:',
    lastNamePlaceholder: 'sobrenome',
    phone: 'Número de Telefone:',
    phonePlaceholder: 'telefone #',
    country: 'País:',
    countryPlaceholder: 'País',
    state: 'Estado:',
    stateProvPlaceholder: 'Estado / Província',
    amount: 'Valor:',
    currency: 'Moeda',
    amountPlaceholder: 'Valor',
    payoutLimits: 'Limites de saque: Mínimo',
    maximum: 'Máximo',
    noLimit: 'Sem Limite',
    beneficiaryBankInfo: 'Informações do Banco Beneficiário',
    accountNumber: 'Número de Conta:',
    accountNumberPlaceholder: 'Número de Conta',
    swiftCode: 'Código Swift:',
    swiftCodePlaceholder: 'Código Swift',
    bankName: 'Nome do banco:',
    bankNamePlaceholder: 'nome do banco',
    bankCountry: 'País do Banco:',
    bankState: 'Estado do Banco:',
    bankCity: 'Cidade do Banco:',
    bankCityPlaceholder: 'cidade do banco',
    bankAddress: 'Endereço do Banco:',
    bankAddressPlaceholder: 'endereço do banco',
    intermediaryBankInfo: 'Informações do Banco Intermediário',
    back: 'VOLTAR',
    submit: 'ENVIAR',
    warning: 'Aviso',
    error: 'Erro',
    amountRequired: 'Valor obrigatório',
    withdrawalStatus: 'Status do Saque',
    amountNotPermitted: 'Valor não permitido, por favor verifique seu saldo disponível para saque',
    errorGettingCustomerInfo: 'Erro ao obter informações do cliente: ',
  },
}

export default translations
